import React from 'react'

/**
 * Shared progress bar component for WaitScreen
 * Displays course generation progress with percentage label
 *
 * @param {number} progress - Progress value (0-100)
 * @returns {JSX.Element}
 */
export const ProgressBar = ({ progress }) => {
  // Ensure progress is within valid range
  const progressValue = Math.max(0, Math.min(100, progress))
  const progressLabel = `${Math.round(progressValue)}%`

  return (
    <div className="wait-screen-progress-container">
      <div className="wait-screen-progress-row">
        <div className="wait-screen-progress-track">
          <div
            className="wait-screen-progress-fill"
            style={{ width: `${progressValue}%` }}
          />
        </div>
        <span className="wait-screen-progress-percent">{progressLabel}</span>
      </div>
    </div>
  )
}

export default ProgressBar
